module.exports = __webpack_public_path__ + "static/media/phone.34d66e54.png";